<template>
  <fragment>
    <v-form @submit.prevent="filterPackageEmission" class="search-forms">
      <v-row class="mb-7">
        <v-col cols="12" md="3" sm="4">
          <BaseAutocomplete
            clearable
            label="Consumidor"
            item-text="nome"
            item-value="idconsumidor"
            no-data-text="Nenhum consumidor encontrado"
            placeholder="Selecione o consumidor"
            tabindex="2"
            :items="consumerWithPackagePermission"
            :loading="sendingPackagesLoading"
            v-model="filter.consumer"
          >
            <template v-slot:selection="{ item }">
              {{ item.nome }}
            </template>
          </BaseAutocomplete>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu"
            v-model="menu"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Inicial"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.initDateView"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.initDate"
              :active-picker.sync="activePicker"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu2"
            v-model="menu2"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Final"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.endDateView"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.endDate"
              :active-picker.sync="activePicker2"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save2"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col class="d-flex justify-end">
          <BaseButton
            type="submit"
            variant="filter"
            class="button rounded-xxl"
            :loading="sendingPackagesLoading"
          >
            Filtrar
          </BaseButton>
        </v-col>
      </v-row>
      <v-data-table
        class="mb-10"
        no-data-text="Não há registro de emissão de pacotes."
        loading-text="Buscando informações..."
        :loading="sendingPackagesLoading"
        :headers="headers"
        :items="allSendingPackages.info"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Pacotes por página:',
        }"
      >
        <template v-slot:item.nome="{ item }">
          {{ item.nome || "-" }}
        </template>
        <template v-slot:item.taxa_pacote="{ item }">
          {{ formatCurrency(item.taxa_pacote) }}
        </template>
        <template v-slot:item.taxa_cortesia="{ item }">
          {{ formatCurrency(item.taxa_cortesia) }}
        </template>
        <template v-slot:item.taxa_gratuidade="{ item }">
          {{ formatCurrency(item.taxa_gratuidade) }}
        </template>
      </v-data-table>
      <v-data-table
        hide-default-footer
        no-data-text="Não há registro de emissão de pacotes."
        loading-text="Buscando informações..."
        :loading="sendingPackagesLoading"
        :headers="headersTotais"
        :items="allSendingPackages.totals"
      >
        <template v-slot:item.valor_total_taxa_pacote="{ item }">
          {{ formatCurrency(item.valor_total_taxa_pacote) || "R$ 0,00" }}
        </template>
        <template v-slot:item.valor_total_taxa_cortesia="{ item }">
          {{ formatCurrency(item.valor_total_taxa_cortesia) || "R$ 0,00" }}
        </template>
        <template v-slot:item.valor_total_taxa_gratuidade="{ item }">
          {{ formatCurrency(item.valor_total_taxa_gratuidade) || "R$ 0,00" }}
        </template>
      </v-data-table>
    </v-form>
  </fragment>
</template>
<script>
import dayjs from "dayjs";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import { formatCurrency } from "@/utils/productPackage.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "PackageEmission",
  metaInfo: {
    title: "Relatório Sintético de Emissão de Pacotes | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Relatório Sintético de Emissão de Pacotes | ElevenTickets",
      },
    ],
  },
  components: {
    BaseAutocomplete,
    BaseTextField,
    BaseButton,
  },
  data() {
    return {
      formatCurrency,
      filter: {
        consumer: null,
        initDate: "",
        initDateView: "",
        endDate: "",
        endDateView: "",
      },
      actions: [
        {
          id: "CSV",
          name: "",
          icon: "mdi-microsoft-excel",
          action: () => this.exportCSV(),
          loading: this.exportCSVLoading,
        },
        {
          id: "PDF",
          name: "",
          icon: "mdi-file-pdf-box",
          action: () => this.exportPDF(),
          loading: this.exportPDFLoading,
        },
      ],
      dayjs: dayjs,
      activePicker: null,
      activePicker2: null,
      date: null,
      menu: false,
      menu2: false,
      headers: [
        {
          text: "Pedido",
          align: "center",
          sortable: false,
          value: "pedido",
        },
        {
          text: "Nome",
          align: "center",
          value: "nome",
        },
        {
          text: "Taxa de pacote",
          align: "center",
          value: "taxa_pacote",
        },
        {
          text: "Taxa de cortesia",
          align: "center",
          value: "taxa_cortesia",
        },
        {
          text: "Taxa de Gratuídade",
          align: "center",
          value: "taxa_gratuidade",
        },
      ],
      headersTotais: [
        {
          text: "Total taxa de pacote",
          align: "center",
          sortable: false,
          value: "valor_total_taxa_pacote",
        },
        {
          text: "Total taxa de cortesia",
          align: "center",
          sortable: false,
          value: "valor_total_taxa_cortesia",
        },
        {
          text: "Total taxa de gratuídade",
          align: "center",
          sortable: false,
          value: "valor_total_taxa_gratuidade",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "allSendingPackages",
      "sendingPackagesLoading",
      "consumer",
    ]),
    consumerWithPackagePermission() {
      const filter = this.consumer.filter(item => {
        return item.permite_pacote === 1;
      });
      return filter;
    },
  },
  watch: {
    "$store.getters.storeSequencial"() {
      if (this.storeSequencial) {
        this.fetchConsumerOptions(this.storeSequencial);
        this.filterPackageEmission();
      }
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
  },
  methods: {
    ...mapActions(["fetchSendingPackages", "fetchConsumerOptions"]),
    ...mapMutations(["setSendingPackagesLoading", "setReportsFilter"]),
    filterPackageEmission() {
      this.setSendingPackagesLoading(true);
      let filter = {};

      if (this.filter.initDateView) {
        Object.assign(filter, {
          dthr_ini: `${this.filter.initDate} 00:00`,
        });
      }

      if (this.filter.endDateView) {
        Object.assign(filter, {
          dthr_fim: `${this.filter.endDate} 23:59`,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        idconsumidor: this.filter.consumer,
      });

      this.fetchSendingPackages(filter);
      this.setReportsFilter(filter);
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    save(date) {
      this.$refs.menu.save(date);
      this.filter.initDateView = dayjs(date).format("DD/MM/YYYY");
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.filter.endDateView = dayjs(date).format("DD/MM/YYYY");
    },
  },
  beforeMount() {
    if (this.storeSequencial) {
      this.fetchConsumerOptions(this.storeSequencial);
      this.fetchSendingPackages({
        producerId: this.storeSequencial,
      });
    }
  },
  destroyed() {
    this.filter = {
      initDate: "",
      initDateView: "",
      endDate: "",
      endDateView: "",
    };
  },
};
</script>
<style scoped></style>
